import { webTypeApiUrl } from "@/constants/webTypeApiUrl";

import store_groupList from "../vuex/store_groupList.js";

export const FriendGroupHandler = {
  AddGroup: function (staffId, groupname, picked, groupId, friendGroupPhotoURL) {

    var url = webTypeApiUrl.MessageAPI + "/Friend/AddFriendGroup";
    //建立群組
    $.ajax({
      url: url,
      type: "post",
      async: false,
      data: {
        groupName: groupname,
        staffId: staffId,
        socialLeadIds: picked,
        groupId: groupId,
        friendGroupPhotoURL: friendGroupPhotoURL
      },
      dataType: "json",
      success: function (data) {
        if (!data.Success) {
          alert(data.DisplayMessage);
        } else {
          //alert('儲存成功');
        }
      },
      error: function (a, b, c) {}
    });
  },
  DeleteGroup: function (staffId, groupId) {

    var url = webTypeApiUrl.MessageAPI + "/Friend/DeleteFriendGroup";
    //刪除群組
    $.ajax({
      url: url,
      type: "post",
      async: false,
      data: {
        staffId: staffId,
        groupId: groupId
      },
      dataType: "json",
      success: function (data) {
        if (!data.Success) {
          alert(data.DisplayMessage);
        } else {}
      },
      error: function (a, b, c) {}
    });
  },
  GetGroup: function (staffId) {
    var group = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Friend/GetFriendGroup",
      type: "post",
      async: false,
      data: {
        staffId: staffId,
      },
      dataType: "json",
      success: function (data) {
        group = data;
        store_groupList.dispatch("setGroupList", group);
        // group.forEach(function (item, index, array) {
        //   item.GroupType = ""
        //   if (index == 0) {
        //     item.GroupType = "favorite",
        //       item.FriendGroupPhotoURL = '../../../static/img/favorite-img.png'
        //   }
        // });

        // group.unshift({
        //   GroupName: "未讀列表",
        //   GroupType: "unreadlist",
        //   FriendGroupPhotoURL: '../../../static/img/bell-img.png'
        // });


        // group.unshift({
        //   GroupName: "全部好友",
        //   GroupType: "all",
        //   FriendGroupPhotoURL: webTypeApiUrl.MessageAPI + "/images/group_img_0.svg"
        // });

      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
    return group;
  },
  GetAllFriend: function (token) {
    var friend;
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Friend/FriendList",
      type: "post",
      cache: false,
      async: false,
      timeout: 60000,
      data: {
        token: token
      },
      dataType: "json",
      success: function (data) {
        if (data.Success) {
          friend = data.list;
        }
      },
      error: function (a, b, c) {}
    });
    return friend;
  }

};



// WEBPACK FOOTER //
// ./src/handler/FriendGroup.js